// import React, { useState } from "react";
// import styles from "./Forgetpassword.module.scss";
// import { Form } from "react-bootstrap";
// import eyeOn from "../../assests/images/view.png";
// import eyeOff from "../../assests/images/hide.png";
// import { ResetMailServices } from "../../services/auth";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { toastError, toastSuccess } from "../../config/ToastModal";

// function ResetPassword() {
//   const router = useNavigate();
//   const [getTokens] = useSearchParams();

//   const getToken=getTokens.get("encryptToken")
//   const [loading, setLoading] = useState(false);
//   const [showpassword, setShowPassword] = useState(false);
//   const [showpasswordconfirm, setShowPasswordconfirm] = useState(false);
//   const [errors, setErrors] = useState("");
//   const [passwords, setPasswords] = useState({
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const { newPassword, confirmPassword } = passwords;
//   const [error, setError] = useState(false);
//   const changepasswordDatas = [
//     {
//       id: 1,
//       label: "New Password",
//       name: "newPassword",
//       value: newPassword,
//     },
//     {
//       id: 2,
//       label: "Confirm Password",
//       name: "confirmPassword",
//       value: confirmPassword,
//     },
//   ];
//   const handleChange = async (e) => {
//     setPasswords({ ...passwords, [e.target.name]: e.target.value });
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     if (newPassword?.length > 0 && confirmPassword?.length > 0) {
//       if (newPassword === confirmPassword) {
//         const datas = {
//           encryptToken: getToken,
//           newPassword: newPassword,
//           confirmPassword: confirmPassword,
//         };

//         if (getToken && newPassword && confirmPassword) {
//           const { status, message, errors } = await ResetMailServices(datas);

//           if (status) {
//             toastSuccess("Reset Password Changed Successfully");
//             setErrors("");
//             setTimeout(() => {
//               setLoading(false);
//               router("/");
//             }, 800);
//           } else {
//             if (errors) {
//               for (const [key, value] of Object.entries(passwords)) {
//                 for (const [keys, values] of Object.entries(errors)) {
//                   if (key == keys) {
//                     setErrors(values);
//                   }
//                 }
//               }
//             }
//             setLoading(false);
//           }
//         } else {
//           toastError("Something Missing Field");
//           setLoading(false);
//         }
//       } else {
//         setErrors("Password Not Matched");
//         setLoading(false);
//       }
//     } else {
//       setError(true);
//       setLoading(false);
//     }
//   };

//   const togglePasswordVisibility = (params) => {
//     if (params == "New Password") {
//       setShowPassword((pre) => !pre);
//     } else {
//       setShowPasswordconfirm((pre) => !pre);
//     }
//   };
//   return (
//     <div className={styles.mainforgetpassword}>
//       <div className={styles.insideforget}>
//         <div className={styles.forgetpasswordtexts}>Forget Password</div>
//         <div className="mt-3 mb-3">
//           <div className="mb-2 mt-2">
//             {errors && <div className="text-danger">{errors}</div>}
//           </div>

//           {changepasswordDatas?.map((item, index) => {
//             return (
//               <div>
//                 <div className={styles.formgroup}>
//                   <label className={styles.label}>{item?.label}</label>
//                   <Form.Control
//                     type={
//                       item?.label == "New Password"
//                         ? showpassword
//                           ? "text"
//                           : "password"
//                         : item.label == "Confirm Password"
//                         ? showpasswordconfirm
//                           ? "text"
//                           : "password"
//                         : null
//                     }
//                     name={item?.name}
//                     placeholder={`Enter Your ${item?.label}`}
//                     onChange={handleChange}
//                     value={item?.value}
//                     className={styles.passwordinputbox}
//                   />
//                   <div>
//                     <img
//                       src={
//                         item?.label == "New Password"
//                           ? showpassword
//                             ? eyeOn
//                             : eyeOff
//                           : item?.label == "Confirm Password"
//                           ? showpasswordconfirm
//                             ? eyeOn
//                             : eyeOff
//                           : null
//                       }
//                       className={
//                         item?.label == "New Password"
//                           ? styles.newpassword
//                           : styles.resetpassword
//                       }
//                       alt={showpassword ? "password-close" : "password-open"}
//                       onClick={() => {
//                         if (item?.label == "New Password") {
//                           togglePasswordVisibility(item?.label);
//                         } else {
//                           togglePasswordVisibility(item?.label);
//                         }
//                       }}
//                       style={{ cursor: "pointer" }}
//                     />
//                   </div>
//                   {error && item?.value?.length <= 0 ? (
//                     <div className="text-danger">{item?.label} is required</div>
//                   ) : null}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//         <div className="mt-4 mb-4">
//           <button onClick={handleSubmit} className="btns-new">
//             {loading ? "...Loading" : "Change Reset password"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ResetPassword;

import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toastError, toastSuccess } from "../../config/ToastModal";
import { ResetMailServices } from "../../services/auth";
import eyeOn from "../../assests/images/view.png";
import eyeOff from "../../assests/images/hide.png";
import "./Forgetpassword.scss";

function ResetPassword() {
  const router = useNavigate();
  const [getTokens] = useSearchParams();
  const getToken = getTokens.get("encryptToken");

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState("");
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const { newPassword, confirmPassword } = passwords;

  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (newPassword && confirmPassword) {
      if (newPassword === confirmPassword) {
        const datas = {
          encryptToken: getToken,
          newPassword,
          confirmPassword,
        };

        const { status, message, errors } = await ResetMailServices(datas);

        if (status) {
          toastSuccess("Reset Password Changed Successfully");
          setErrors("");
          setTimeout(() => {
            setLoading(false);
            router("/");
          }, 800);
        } else {
          if (errors) {
            for (const key of Object.keys(passwords)) {
              if (errors[key]) setErrors(errors[key]);
            }
          }
          setLoading(false);
        }
      } else {
        setErrors("Passwords do not match");
        setLoading(false);
      }
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const toggleVisibility = (field) => {
    if (field === "new") {
      setShowPassword((prev) => !prev);
    } else {
      setShowPasswordConfirm((prev) => !prev);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={10} md={6} lg={4}>
          <div className="p-4 border rounded shadow-sm bg-white">
            <h4 className="text-center mb-4">Reset Password</h4>

            {errors && <div className="text-danger text-center">{errors}</div>}

            <Form onSubmit={handleSubmit}>
              {/* New Password */}
              <Form.Group className="mb-3 position-relative">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={handleChange}
                />
                <img
                  src={showPassword ? eyeOn : eyeOff}
                  alt="toggle"
                  onClick={() => toggleVisibility("new")}
                  className="password-eye"
                />
                {error && !newPassword && (
                  <div className="text-danger">New Password is required</div>
                )}
              </Form.Group>

              {/* Confirm Password */}
              <Form.Group className="mb-3 position-relative">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type={showPasswordConfirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm your password"
                  value={confirmPassword}
                  onChange={handleChange}
                />
                <img
                  src={showPasswordConfirm ? eyeOn : eyeOff}
                  alt="toggle"
                  onClick={() => toggleVisibility("confirm")}
                  className="password-eye"
                />
                {error && !confirmPassword && (
                  <div className="text-danger">
                    Confirm Password is required
                  </div>
                )}
              </Form.Group>

              <button
                type="submit"
                disabled={loading}
                className="w-100 mt-3 theme-btn btn-style-one"
              >
                {loading ? "Processing..." : "Change Password"}
              </button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
